// apps/dashboard/src/lib/use-consent.ts
'use client';

import { useSyncExternalStore } from 'react';
import {
  hasAnalyticsConsent,
  getStoredConsent,
  hasBrowserDenialSignal,
  type ConsentValue,
  shouldPromptForConsent,
  subscribeToConsent,
} from './consent';

// Server snapshots are all `false`, so the server render and the first client render
// agree (no hydration mismatch); the real value lands right after hydration.

/** True while the visitor still has to be asked (drives the banner). */
export function useConsentPrompt(): boolean {
  return useSyncExternalStore(subscribeToConsent, shouldPromptForConsent, () => false);
}

/** True while the event SDK is allowed to collect. */
export function useAnalyticsConsent(): boolean {
  return useSyncExternalStore(subscribeToConsent, hasAnalyticsConsent, () => false);
}

/** False when a DNT/GPC signal makes the choice moot, so "cookie settings" controls hide. */
export function useCanChangeConsent(): boolean {
  return useSyncExternalStore(subscribeToConsent, () => !hasBrowserDenialSignal(), () => false);
}

/** The stored choice (null = none yet). Used by the settings card to show current state. */
export function useStoredConsent(): ConsentValue | null {
  return useSyncExternalStore(subscribeToConsent, getStoredConsent, () => null);
}
